"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _default = exports.default = {
  methods: {
    /** 渲染表格
     * @description: 渲染表格
     * @return { void }
     */
    renderTable: function renderTable() {
      var _this = this;
      this.$$debounce(function () {
        /* 设置 表格 参数 */
        Object.keys(_this.$attrs).forEach(function (key) {
          return _this.$attrs[key] === '' && (_this.$attrs[key] = true);
        });
        if (typeof _this.$attrs.lazy !== 'undefined') _this.table.lazy = _this.$attrs.lazy;

        /* 设置分页 */
        // if (!this.staticTable) {
        //   const p1 = this.$attrs.pagination
        //   const p2 = this.paginationOptions
        //   console.log(p1, p2);
        //   if (typeof p1 === 'object') this.$$deepMerge(this.pagination, p1)
        //   if (typeof p2 === 'object') this.$$deepMerge(this.pagination, p2)
        // }

        /*  */
        if (typeof _this.dataSource.auto === 'undefined') _this.dataSource.auto = true;
        _this.$nextTick(function () {
          return _this.doLayout();
        });
      }, 50, false);
    },
    /**
     * @description: 获取 行的唯一标识
     * @param { Object } row 行的条目数据
     * @return { String } 行唯一标识
     */
    getRowKey: function getRowKey(row) {
      var _this$table$this$$$fu;
      /* 如果 row-key 是一个方法，那就直接调用这个方法(因为说明这个是调用组件的人想用自己的方法) */
      var rowKey = (_this$table$this$$$fu = this.table[this.$$fuzzySearchFieldName('row-key', this.table)]) !== null && _this$table$this$$$fu !== void 0 ? _this$table$this$$$fu : '';
      if (typeof rowKey === 'function') return rowKey(row);
      try {
        /* 行数据不为空 */
        if (this.$$isNoEmpty(row)) {
          /* 指定 key 存在，就用指定 key */
          if (rowKey && row[rowKey]) return row[rowKey];
          /* 如果没有指定字段，或者指定字段不存在，就用 id */else if (row.id) return row.id;

          /* 如果都不存在，那么就获取当前对象中，除数据类型为 object 以外的数据的 json串作为唯一key */
          var data = (0, _objectSpread2.default)({}, row);

          /* 干掉一些多余的数据防止过长 */
          Object.keys(row).filter(function (k) {
            return (0, _typeof2.default)(row[k]) === 'object';
          }).forEach(function (k) {
            return delete data[k];
          });
          Object.keys(this.getTreeProps()).forEach(function (k) {
            return delete data[k];
          });
          return (0, _jsMd.default)(JSON.stringify(data) + Math.random());
        }
      } catch (e) {}

      /* 行数据为空，直接返回一个随机 key （ 时间 + 随机数 ） */
      return (0, _jsMd.default)(new Date() + Math.random());
    },
    /**
     * @description: 获取 行的标签
     * @param { Object } row 行的条目数据
     * @return { String } 行标签
     */
    getRowLabel: function getRowLabel(row) {
      var _this$table$this$$$fu2, _row$rowLabel;
      var rowLabel = (_this$table$this$$$fu2 = this.table[this.$$fuzzySearchFieldName('row-label', this.table)]) !== null && _this$table$this$$$fu2 !== void 0 ? _this$table$this$$$fu2 : '';
      return row ? (_row$rowLabel = row[rowLabel]) !== null && _row$rowLabel !== void 0 ? _row$rowLabel : '' : '';
    },
    /** 获取 表格 嵌套数据参数
     * @return { Object } 嵌套数据参数
     */
    getTreeProps: function getTreeProps() {
      var _this$table$treeProp, _treeProps$children, _treeProps$hasChildre;
      var treeProps = (_this$table$treeProp = this.table['tree-props']) !== null && _this$table$treeProp !== void 0 ? _this$table$treeProp : {};
      (_treeProps$children = treeProps.children) !== null && _treeProps$children !== void 0 ? _treeProps$children : treeProps.children = 'children';
      (_treeProps$hasChildre = treeProps.hasChildren) !== null && _treeProps$hasChildre !== void 0 ? _treeProps$hasChildre : treeProps.hasChildren = 'hasChildren';
      return treeProps;
    },
    /** 获取 单元格属性
     * @description: 添加行操作按钮
     * @param { Object } scope 行对象
     * @param { Object } scope.row 行数据对象
     * @param { Number } scope.$index 行下标
     * @param { Object } scope.column 列数据对象
     * @param { Object } scope.store 列节点
     * @param { Object } scope.treeNode 树节点信息（只有有子级的节点才会有这个对象）
     * @param { Object } scope._self 当前VUE实例
     * @return { String } 单元格显示内容
     */
    getColumnLable: function getColumnLable(scope) {
      var row = scope.row,
        column = scope.column;

      // 标签
      var a = row[column.property];
      var treeNode = scope.treeNode;
      if (treeNode) {
        var key = this.getRowKey(row);
        var b = this.tableTreeNode[key];
        var className = ".el-table__body-wrapper tr.row-key-".concat(key, " td.bind-field-").concat(column.property, " .el-table__expand-icon");
        var data = {
          treeNode: treeNode,
          className: className,
          key: key,
          label: a
        };
        if (b) Object.assign(b, data);else {
          this.tableTreeNode[key] = data;
        }
      }
      if (typeof column.formatter === 'function') {
        var fun = column.formatter(row, column, a);
        if (this.$$dataTypeOf(fun, true) === '[object Promise]') return '';
        return fun;
      } else return a;
      // return typeof column.formatter === 'function' ? column.formatter(row, column, a) : a
    },
    /** 设置 当前行树设置
     * @description: 设置当前行树
     * @param { Object } scope 行对象
     * @param { Object } scope.row 行数据对象
     * @param { Number } scope.$index 行下标
     * @param { Object } scope.column 列数据对象
     * @param { Object } scope.store 列节点
     * @param { Object } scope.treeNode 树节点信息（只有有子级的节点才会有这个对象）
     * @param { Object } scope._self 当前VUE实例
     * @return { void }
     */
    setRowTreeNode: function setRowTreeNode() {} /* scope */,
    /**
     * @description: select-radio 单选行事件
     * @param { Object } row 行数据
     * @return { void }
     */
    tableSelectRadio: function tableSelectRadio(row) {
      var _this2 = this;
      this.$$debounce(function () {
        if (_this2.isSingle) {
          var _this2$$refs$elTable, _this2$$refs$elTable2;
          var a = _this2.getRowKey(row) !== _this2.selectionRadio;
          (_this2$$refs$elTable = _this2.$refs['el-table']) === null || _this2$$refs$elTable === void 0 || _this2$$refs$elTable.clearSelection();
          (_this2$$refs$elTable2 = _this2.$refs['el-table']) === null || _this2$$refs$elTable2 === void 0 || _this2$$refs$elTable2.toggleRowSelection(row, a);
        }
      });
    },
    /**
     * @description: 设置行序号
     * @param { Object } scope 行数据对象
     * @return { void }
     */
    setRowIndex: function setRowIndex(scope) {
      var _ref,
        _this3 = this;
      var a = this.table.index;
      var row = scope.row,
        $index = scope.$index;
      if (a && typeof a === 'function') return a(row, $index);
      var _this$pagination = this.pagination,
        currentPage = _this$pagination.currentPage,
        pageSize = _this$pagination.pageSize;
      var _self = scope._self,
        column = scope.column;
      var index = scope.$index + 1 + ((_ref = (currentPage - 1) * pageSize) !== null && _ref !== void 0 ? _ref : 0);

      /* 序号宽度算法，防止序号过长的时候换行 */
      this.$$debounce(function () {
        var l = (index + '').length;
        var cellDoms = _self === null || _self === void 0 ? void 0 : _self.$el.querySelectorAll(".el-table__body-wrapper .".concat(column.id));
        var b = _this3.$$getDomSize(cellDoms[0], 'font-size');
        var c = _this3.$$deepMerge({}, _this3.columnOptions, _this3.columnIndexOptions);
        if (!c.width) {
          var width = _this3.columnOption.index.width;
          var w = b / 2 * (l + 1) + 20;
          if (w > width) {
            Object.assign(_this3.columnOption.index, {
              width: b / 2 * (l + 1) + 20,
              'min-width': _this3.columnOption.index.width
            });
          }
        }
      }, 1000);
      return index;
    },
    /** 添加行操作按钮
     * @description: 添加行操作按钮
     * @param { Object } row 行数据对象
     * @return { void }
     */
    addRowOperations: function addRowOperations(row) {
      var _this4 = this;
      var key = this.$$getMD5(row);
      var a = this.tableRowOperations;
      !JSON.stringify(a).includes(key) && a.push(this.rowOperations.map(function (btn) {
        return _this4.$$handleButton((0, _objectSpread2.default)({
          rowKey: key
        }, btn), row);
      }));
    },
    /** 获取行的状态
     * @param { Object | Strins } row 行数据对象 或者 行的 row-key
     * @return { void }
     */
    getRowStauts: function getRowStauts() {
      var _this$$refs$elTable,
        _this$$refs$elTable2,
        _this5 = this;
      var a0 = arguments[0];
      var key = (0, _typeof2.default)(a0) === 'object' ? this.getRowKey(a0) : a0;
      var _this$$refs$elTable$ = (_this$$refs$elTable = this.$refs['el-table']) === null || _this$$refs$elTable === void 0 ? void 0 : _this$$refs$elTable.store,
        states = _this$$refs$elTable$.states;
      var treeNode = states === null || states === void 0 ? void 0 : states.treeData[key];
      if (treeNode) return treeNode;
      var lazyTreeNodeMap = (_this$$refs$elTable2 = this.$refs['el-table']) === null || _this$$refs$elTable2 === void 0 || (_this$$refs$elTable2 = _this$$refs$elTable2.store) === null || _this$$refs$elTable2 === void 0 || (_this$$refs$elTable2 = _this$$refs$elTable2.states) === null || _this$$refs$elTable2 === void 0 ? void 0 : _this$$refs$elTable2.lazyTreeNodeMap;
      var parentKey = Object.keys(lazyTreeNodeMap).filter(function (k) {
        return JSON.stringify(lazyTreeNodeMap[k]).includes(k);
      }).find(function (k) {
        var _lazyTreeNodeMap$k;
        return (_lazyTreeNodeMap$k = lazyTreeNodeMap[k]) === null || _lazyTreeNodeMap$k === void 0 ? void 0 : _lazyTreeNodeMap$k.find(function (subData) {
          return _this5.getRowKey(subData) === key;
        });
      });
      if (parentKey && states !== null && states !== void 0 && states.treeData[parentKey]) return {
        loading: states === null || states === void 0 ? void 0 : states.treeData[parentKey].loading
      };
      return {};
    },
    /** 获取行的状态
     * @param { Object | Strins } row 行数据对象 或者 行的 row-key
     * @return { void }
     */
    setTableRowLoading: function setTableRowLoading() {
      var _this$$refs$elTable3;
      var a0 = arguments[0];
      var key = (0, _typeof2.default)(a0) === 'object' ? this.getRowKey(a0) : a0;
      // const { states } = this.$refs['el-table']?.store
      var treeNode = this.getRowStauts(key);
      var trs = (_this$$refs$elTable3 = this.$refs['el-table']) === null || _this$$refs$elTable3 === void 0 || (_this$$refs$elTable3 = _this$$refs$elTable3.$el) === null || _this$$refs$elTable3 === void 0 ? void 0 : _this$$refs$elTable3.querySelectorAll('tr.row-key-' + key);
      trs === null || trs === void 0 || trs.forEach(function (tr) {
        if (treeNode !== null && treeNode !== void 0 && treeNode.loading) tr.classList.add('row-disabled');else tr.classList.remove('row-disabled');
      });
      return true;
    },
    /** 监听表格尺寸变化
     * @description:
     * @return { void }
     */
    wacthTableSize: function wacthTableSize() {
      //   this.openRequest = !this.autoPageSize
      //   this.autoPageSize && this.$nextTick(() => {
      //     try {
      //       if (this.table.data.length < 1) this.table.data = [{}]

      //       this.$observer = this.$$observer(this.$el, () => {
      //         /* 加一条空数据作为行计算操作标准,没有数据的时候才能这么操作，否则会出问题 */

      //         const a = this.$refs['el-table']
      //         const b = a?.$refs?.bodyWrapper
      //         const c = b?.querySelector('.el-table__body')

      //         if (b && c?.clientHeight && c?.clientHeight < b?.clientHeight) {
      //           const trs = c.querySelectorAll('tr')

      //           if (trs[0]) {
      //             const h = parseInt(b.clientHeight / trs[0].clientHeight / 10, 10) * 10 || this.pagination['page-sizes'][0]

      //             /* 防止出现 0 行的bug */
      //             if (h > this.pagination['page-sizes'][0]) this.pagination.pageSize = h
      //           }
      //         }

      //         if (this.table?.data?.length === 1 && this.$$isEmpty(this.table.data[0])) this.table.data.length = 0

      //         this.openRequest = true
      //       })
      //     } catch (e) {
      //       this.openRequest = true
      //     }
      //   })
    }
  }
};